import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { NotificationTheme } from '@fcom/ui-components';
import { ReplaceParams } from '@fcom/core/utils';

export enum NotificationWarning {
  NO_FLIGHTS = 'noFlights',
  NO_AWARD_FLIGHTS = 'noAwardFlights',
  NO_FLIGHTS_FOR_ROUTE = 'noFlightsForRoute',
  NO_AWARD_FLIGHTS_FOR_ROUTE = 'noAwardFlightsForRoute',
  SEASONAL_ROUTE = 'seasonalRoute',
  REGULATORY = 'regulatory',
  GENERAL = 'general',
}

export enum NotificationSpecific {
  DESTINATION_SPECIFIC = 'destinationSpecific',
  BUS_CONNECTION = 'busConnection',
  TRAIN_CONNECTION = 'trainConnection',
  AM_EARN_POINTS = 'amEarnPoints',
  MULTICITY_NOT_CONSECUTIVE = 'multiCityNotConsecutive',
  MULTICITY_MAX_NUMBER_OF_FLIGHTS = 'multiCityMaxNumberOfFlights',
  CORPORATE_USER = 'corporateUser',
}

export type NotificationType = NotificationWarning | NotificationSpecific;

export interface NotificationData {
  type: NotificationType;
  theme: NotificationTheme;
  icon?: SvgLibraryIcon;
  isCloseable?: boolean;
  text: {
    label: string;
    params?: ReplaceParams;
  };
  text1?: {
    label: string;
    params?: ReplaceParams;
  };
  link?: {
    text: string;
    url: string;
    external?: boolean;
    openInNewTab?: boolean;
  };
  removePadding?: boolean;
}

export interface SeasonalNotificationData {
  start?: string;
  end?: string;
  start2?: string;
  end2?: string;
}
